export const DEFAULT_FRONTEND_TIMEZONE = 'America/New_York';

export const BRANDS_LIST_PAGE_LIMIT = 50;
